import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Text from '../components/elements/TextComponent';
import InputField from '../components/elements/InputField';
import TextWithButton from '../components/elements/TextWithButtonComponent';
import Button from '../components/elements/Button';
import ImageComponent from '../components/elements/ImageComponent';
import userAtDesk from '../assets/userAtDesk.svg';
import { loginUser } from '../api/userApi';

const PURPLE_HEIGHT = 240;

const MobileLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [imageSize, setImageSize] = useState(160);
  const whiteSectionRef = useRef<HTMLDivElement>(null);
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    const update = () => {
      const vh = window.visualViewport?.height || window.innerHeight;
      const keyboardHeight = window.innerHeight - vh;

      setKeyboardOpen(keyboardHeight > 100);

      const w = window.innerWidth;
      const size = Math.min(w * 0.45, vh * 0.3);
      setImageSize(Math.max(140, Math.min(size, 220)));
    };

    update();
    window.visualViewport?.addEventListener('resize', update);
    window.addEventListener('resize', update);
    return () => {
      window.visualViewport?.removeEventListener('resize', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  const handleLogin = async () => {
    const result = await loginUser({ email, password });
    if (result.error) {
      setStatus('error');
      setMessage('Incorrect Email or Password');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        fontFamily: 'Montserrat',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 🟪 Top Purple Section */}
      <div
        style={{
          height: PURPLE_HEIGHT,
          backgroundColor: 'var(--primary)',
          padding: '24px 16px',
          display: keyboardOpen ? 'none' : 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <ImageComponent
          src={userAtDesk}
          center
          style={{
            width: `${imageSize}px`,
            height: `${imageSize}px`,
            objectFit: 'contain',
          }}
        />
        <div>
          <Text
            text="ComeChatWithMe.ai"
            fontSize="24px"
            fontWeight="700"
            color="#ffffff"
            textAlign="center"
            navigateToHome
          />
          <Text
            text="Login to manage your assistants"
            fontSize="14px"
            fontWeight="400"
            color="#ffffff"
            textAlign="center"
          />
        </div>
      </div>

      {/* ⚪ Scrollable White Section */}
      <div
        ref={whiteSectionRef}
        style={{
          flex: 1,
          backgroundColor: '#ffffff',
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          overflowY: 'auto',
          padding: '24px 20px 160px',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Text text="Log in" fontSize="24px" fontWeight="700" color="#030303" textAlign="left" />

        <div style={{ marginTop: 12 }}>
          <TextWithButton
            text="Login or "
            fontSize="14px"
            fontWeight="400"
            color="#030303"
            textAlign="left"
            showButton
            buttonLabel="register"
            onButtonClick={() => navigate('/register')}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          <InputField
            text="Enter your email"
            fontSize="16px"
            fontWeight={500}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          <Text
            text="Password"
            fontSize="16px"
            fontWeight="400"
            color="#030303"
            textAlign="left"
          />
        </div>

        <InputField
          text=""
          fontSize="16px"
          fontWeight={500}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <div style={{ marginTop: 8, marginBottom: 20 }}>
          <a
            href="/forgot-password"
            style={{
              color: 'var(--primary)',
              fontFamily: 'Montserrat',
              fontSize: '14px',
              textDecoration: 'underline',
            }}
          >
            Forgot your password?
          </a>
        </div>

        {status !== 'idle' && (
          <p
            style={{
              fontFamily: 'Montserrat',
              fontSize: '14px',
              color: status === 'success' ? '#2e7d32' : '#d32f2f',
              textAlign: 'left',
              marginTop: 10,
            }}
          >
            {message}
          </p>
        )}

        <div style={{ marginTop: 24 }}>
          <Button
            label="Log in"
            backgroundColor="var(--primary)"
            color="#ffffff"
            onClick={handleLogin}
          />
        </div>

        {/* Terms */}
        <div style={{ marginTop: 24, fontSize: 14, textAlign: 'center' }}>
          <a
            href="/termsofservice"
            style={{ color: 'var(--primary)', textDecoration: 'underline', marginRight: 12 }}
          >
            Terms of Service
          </a>
          <a href="/privacypolicy" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileLogin;
